"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkType = void 0;
var LinkType;
(function (LinkType) {
    LinkType["RolAdapterLink"] = "RolAdapterLink";
    LinkType["RolAutoglideLink"] = "RolAutoglideLink";
    LinkType["RolLink"] = "RolLink";
    LinkType["RolModifiedLink"] = "RolModifiedLink";
    LinkType["StandardLink"] = "StandardLink";
})(LinkType = exports.LinkType || (exports.LinkType = {}));
//# sourceMappingURL=LinkType.js.map